import {FormControl, TextInput, ThemeProvider, Button} from '@primer/react-brand/esm'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {t} from '@github-ui/swp-core/lib/utils/localization'

import {
  resolveGenericContentCta,
  type GenericContent,
  type GenericCtaCondition,
} from '../../../../brand/lib/types/contentful'

import {CtaButtons} from './CtaButtons'

type Props = {
  contentfulContent: GenericContent
  location: string
}

export function CtaGroup(props: Props) {
  const {isLoggedIn = false, hasOrganization = false} = useRoutePayload<{
    isLoggedIn: boolean
    hasOrganization: boolean
  }>()

  const {contentfulContent, location} = props
  const conditions: GenericCtaCondition[] = []

  if (isLoggedIn && hasOrganization) {
    conditions.push('hasOrganization')
  }

  if (isLoggedIn) {
    conditions.push('isLoggedIn')
  }

  const cta = resolveGenericContentCta(contentfulContent, {conditions})

  if (!cta) {
    return null
  }

  if (cta.condition !== 'default') {
    return <CtaButtons contentfulContent={cta} location={location} />
  }

  const {primary, secondary} = cta

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className={`CtaForm${location !== 'hero' ? ' CTAForm-footer' : ''}`}>
      <form action={primary.fields.href} method="get" acceptCharset="UTF-8" aria-label={primary.fields.text}>
        <input type="hidden" name="source" value="form-home-signup" />

        {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
        <FormControl className="CtaFormControl">
          {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
          <ThemeProvider colorMode="light" className="CtaFormControl-container">
            {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
            <div className="CtaFormControl-field-wrap">
              {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
              <FormControl.Label className="CtaFormControl-label" htmlFor={`${location}_user_email`}>
                {t('Enter your email')}
              </FormControl.Label>

              <TextInput
                /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
                className="CtaFormControl-input"
                id={`${location}_user_email`}
                type="email"
                autoComplete="email"
                spellCheck="false"
                name="user_email"
                placeholder="you@domain.com"
              />
            </div>

            <Button
              /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
              className={`CtaForm-primaryAction CtaFormControl-button ${location === 'hero' ? 'js-hero-action' : ''}`}
              type="submit"
              variant="primary"
              {...getAnalyticsEvent({action: primary.fields.text, tag: 'button', context: 'CTAs', location})}
            >
              {primary.fields.text}
            </Button>
          </ThemeProvider>
        </FormControl>
      </form>

      {secondary ? (
        <Button
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          className={`CtaForm-secondaryAction CtaForm-nextToFormAction ${location === 'hero' ? 'js-hero-action' : ''}`}
          as="a"
          href={secondary.fields.href}
          {...getAnalyticsEvent({action: secondary.fields.text, tag: 'button', context: 'CTAs', location})}
        >
          {secondary.fields.text}
        </Button>
      ) : null}
    </div>
  )
}
